module.exports = __webpack_public_path__ + "img/icon-vehicle-type-n3.610b951b.svg";